import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { setCommonAmmControlloListeners } from '../../listeners/amm-controllo-common.form-listeners';
import { my_CkNormeListenerHelper } from '../../listeners/amm-controllo-norme.listeners';
import { my_AllConsAmmDataElezioneListenerHelper, my_AllConsAmmCaricaListenerHelper } from '../../listeners/amm-controllo-consiglio-amm.listeners';
import { my_AllRevisoriControlloContabileListenerHelper } from '../../listeners/amm-controllo-collegio-sindacale.listeners';
import { my_AllLiquidatoriCaricaListenerHelper } from '../../listeners/amm-controllo-liquidatori.listeners';
import { my_AllConsAmmComuneProvinciaCH, my_AllLiquidatoriComuneCH } from '../../common/helpers/norme-comune-provincia.helper';
import { my_SpmComitGestComuneCH } from '../../common/helpers/norme-spa-helpers.helper';
import { my_SpmCoop9SociListenerHelper } from '../../common/helpers/coop-soci-listener.helper';
import { setNormeSpaMonisticoSpmSpecificListeners } from './norme-spa-monistico-spm-specific.listeners';

export class NormeSpaMonisticoFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setNormeSpaMonisticoSpmSpecificListeners(this.form, this.store);
        setCommonAmmControlloListeners(this.form, this.store);
        my_CkNormeListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaMonistico);
        my_AllLiquidatoriCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaMonistico);
        my_AllRevisoriControlloContabileListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaMonistico);
        my_AllConsAmmDataElezioneListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaMonistico);
        my_AllConsAmmComuneProvinciaCH(this.form, this.store);
        my_AllLiquidatoriComuneCH(this.form, this.store);
        my_SpmComitGestComuneCH(this.form, this.store);
        my_AllConsAmmCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSpaMonistico);
        my_SpmCoop9SociListenerHelper(this.form, this.store);
    }
}
